import React, { useEffect, useState } from 'react';
import { Notification, NotificationContainer } from '@flixbus/honeycomb-react';
import { useNotification } from '../../contexts/NotificationContext';

let nextToastId = 0;

const CustomNotification = () => {
    const { notification } = useNotification();
    const [toasts, setToasts] = useState([]);

    // Every showNotification call creates a new notification object, so each one adds a toast.
    useEffect(() => {
        if (!notification?.message) return;
        setToasts((current) => [...current, { ...notification, id: nextToastId++ }]);
    }, [notification]);

    const removeToast = (id) => setToasts((current) => current.filter((toast) => toast.id !== id));

    return (
        <NotificationContainer position="top-right">
            {toasts.map(({ id, message, appearance }) => (
                <Notification
                    key={id}
                    toast
                    appearance={appearance}
                    // Called by honeycomb when the toast animation ends.
                    dismissCallback={() => removeToast(id)}
                    closeProps={{ 'aria-label': 'Close', onClick: () => removeToast(id) }}
                >
                    {message}
                </Notification>
            ))}
        </NotificationContainer>
    );
};

export default CustomNotification;
